const actionTyper = (prefix = '', separator = '/') => {
  return new Proxy(
    {},
    {
      get(_target, name) {
        return `${prefix}${separator}${name}`
      },
    }
  )
}

export const { LOCATION_CHANGE } = actionTyper('@@router')

export const { LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } = actionTyper('auth')

export const { FETCH_STATUSES, FETCH_STATUSES_SUCCESS, FETCH_STATUSES_FAILURE } = actionTyper('status')

export const {
  FETCH_INDICES,
  FETCH_INDICES_SUCCESS,
  FETCH_INDICES_FAILURE,
  FETCH_INDEX_FAILURE,
  ADD_INDEX,
  ADD_INDEX_SUCCESS,
  ADD_INDEX_FAILURE,
  UPDATE_INDEX,
  UPDATE_INDEX_SUCCESS,
  UPDATE_INDEX_FAILURE,
  REMOVE_INDEX,
  REMOVE_INDEX_SUCCESS,
  REMOVE_INDEX_FAILURE,
} = actionTyper('elasticIndices')

export const {
  FETCH_ALIASES,
  FETCH_ALIASES_SUCCESS,
  FETCH_ALIASES_FAILURE,
  FETCH_ALIAS_FAILURE,
  ADD_ALIAS,
  ADD_ALIAS_SUCCESS,
  ADD_ALIAS_FAILURE,
  UPDATE_ALIAS,
  UPDATE_ALIAS_SUCCESS,
  UPDATE_ALIAS_FAILURE,
  REMOVE_ALIAS,
  REMOVE_ALIAS_SUCCESS,
  REMOVE_ALIAS_FAILURE,
} = actionTyper('elasticAliases')

export const {
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,
  FETCH_TEMPLATE_FAILURE,
  ADD_TEMPLATE,
  ADD_TEMPLATE_SUCCESS,
  ADD_TEMPLATE_FAILURE,
  UPDATE_TEMPLATE,
  UPDATE_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_FAILURE,
  REMOVE_TEMPLATE,
  REMOVE_TEMPLATE_SUCCESS,
  REMOVE_TEMPLATE_FAILURE,
} = actionTyper('elasticTemplates')

export const {
  FETCH_BRANDS,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
  FETCH_VERSIONS,
  FETCH_VERSIONS_SUCCESS,
  FETCH_VERSIONS_FAILURE,
  FETCH_CONTENT_TYPES,
  FETCH_CONTENT_TYPES_SUCCESS,
  FETCH_CONTENT_TYPES_FAILURE,
  FETCH_BRAND_STATUS,
  FETCH_BRAND_STATUS_SUCCESS,
  FETCH_BRAND_STATUS_FAILURE,
  FETCH_BRAND_PROGRESS,
  FETCH_BRAND_PROGRESS_SUCCESS,
  FETCH_BRAND_PROGRESS_FAILURE,
  REINDEX_BRAND,
  REINDEX_BRAND_SUCCESS,
  REINDEX_BRAND_FAILURE,
  STOP_REINDEX,
  STOP_REINDEX_SUCCESS,
  STOP_REINDEX_FAILURE,
  REINDEX_BY_ID,
  REINDEX_BY_ID_SUCCESS,
  REINDEX_BY_ID_FAILURE,
  SET_VERSIONS,
  SET_VERSIONS_SUCCESS,
  SET_VERSIONS_FAILURE,
  SET_CONTENT_TYPES,
} = actionTyper('reindex')

export const {
  FETCH_VERTICALS,
  FETCH_VERTICALS_SUCCESS,
  FETCH_VERTICALS_FAILURE,
  FETCH_SELENE_VERSIONS,
  FETCH_SELENE_VERSIONS_SUCCESS,
  FETCH_SELENE_VERSIONS_FAILURE,
  FETCH_TEMPLATE_TYPES,
  FETCH_TEMPLATE_TYPES_SUCCESS,
  FETCH_TEMPLATE_TYPES_FAILURE,
  FETCH_VERTICAL_STATUS,
  FETCH_VERTICAL_STATUS_SUCCESS,
  FETCH_VERTICAL_STATUS_FAILURE,
  FETCH_VERTICAL_PROGRESS,
  FETCH_VERTICAL_PROGRESS_SUCCESS,
  FETCH_VERTICAL_PROGRESS_FAILURE,
  REINDEX_VERTICAL,
  REINDEX_VERTICAL_SUCCESS,
  REINDEX_VERTICAL_FAILURE,
  STOP_SELENE_REINDEX,
  STOP_SELENE_REINDEX_SUCCESS,
  STOP_SELENE_REINDEX_FAILURE,
  REINDEX_SELENE_BY_ID,
  REINDEX_SELENE_BY_ID_SUCCESS,
  REINDEX_SELENE_BY_ID_FAILURE,
  SET_SELENE_VERSIONS,
  SET_SELENE_VERSIONS_SUCCESS,
  SET_SELENE_VERSIONS_FAILURE,
  SET_TEMPLATE_TYPES,
} = actionTyper('seleneReindex')

export const {
  CONTENT_TYPE_CHANGED,
  BRAND_CHANGED,
  INTERVAL_CHANGED,
  FIELD_CHANGED,
  FETCH_BRANDS_AGGREGATES,
  FETCH_BRANDS_AGGREGATES_SUCCESS,
  FETCH_BRANDS_AGGREGATES_FAILURE,
  FETCH_CONTENT_TYPES_AGGREGATES,
  FETCH_CONTENT_TYPES_AGGREGATES_SUCCESS,
  FETCH_CONTENT_TYPES_AGGREGATES_FAILURE,
  FETCH_DOCUMENTS_AGGREGATES,
  FETCH_DOCUMENTS_AGGREGATES_SUCCESS,
  FETCH_DOCUMENTS_AGGREGATES_FAILURE,
} = actionTyper('elasticAggregates')

export const {
  FETCH_QUEUES,
  FETCH_QUEUES_SUCCESS,
  FETCH_QUEUES_FAILURE,
  FETCH_QUEUE_COUNTS,
  FETCH_QUEUE_COUNTS_FAILURE,
  FETCH_QUEUE_COUNTS_SUCCESS,
  TRIGGER_SERVICE,
  TRIGGER_SERVICE_FAILURE,
  TRIGGER_SERVICE_SUCCESS,
  RETRY_DLQ_MESSAGES,
  RETRY_DLQ_MESSAGES_FAILURE,
  RETRY_DLQ_MESSAGES_SUCCESS,
  CLEAR_DLQ,
  CLEAR_DLQ_FAILURE,
  CLEAR_DLQ_SUCCESS,
} = actionTyper('toaster')

export const { FETCH_CONFIGURATION, FETCH_CONFIGURATION_SUCCESS, FETCH_CONFIGURATION_FAILURE } = actionTyper('configuration')

export const {
  FETCH_EXCLUSION_FILES,
  FETCH_EXCLUSION_FILES_SUCCESS,
  FETCH_EXCLUSION_FILES_FAILURE,
  FETCH_EXCLUSION_FILE,
  FETCH_EXCLUSION_FILE_SUCCESS,
  FETCH_EXCLUSION_FILE_FAILURE,
  ADD_EXCLUSION_FILE,
  ADD_EXCLUSION_FILE_SUCCESS,
  ADD_EXCLUSION_FILE_FAILURE,
  UPDATE_EXCLUSION_FILE,
  UPDATE_EXCLUSION_FILE_SUCCESS,
  UPDATE_EXCLUSION_FILE_FAILURE,
  REMOVE_EXCLUSION_FILE,
  REMOVE_EXCLUSION_FILE_SUCCESS,
  REMOVE_EXCLUSION_FILE_FAILURE,
} = actionTyper('exclusions')

export const {
  SET_AUTO_VERSIONING_VERSION,
  SET_AUTO_VERSIONING_VERSION_SUCCESS,
  SET_AUTO_VERSIONING_VERSION_FAILURE,

  SET_AUTO_VERSIONING_BRANDS,
  SET_AUTO_VERSIONING_BRANDS_SUCCESS,
  SET_AUTO_VERSIONING_BRANDS_FAILURE,

  AUTO_VERSIONING_UNCONFIRM,
  AUTO_VERSIONING_UNCONFIRM_SUCCESS,
  AUTO_VERSIONING_UNCONFIRM_FAILURE,

  AUTO_VERSIONING_KICKOFF,
  AUTO_VERSIONING_KICKOFF_SUCCESS,
  AUTO_VERSIONING_KICKOFF_FAILURE,

  FETCH_AUTO_VERSIONING_PROGRESS,
  FETCH_AUTO_VERSIONING_PROGRESS_SUCCESS,
  FETCH_AUTO_VERSIONING_PROGRESS_FAILURE,

  AUTO_VERSIONING_RESET,
  AUTO_VERSIONING_RESET_SUCCESS,
  AUTO_VERSIONING_RESET_FAILURE,

  AUTO_VERSIONING_CANCEL,
  AUTO_VERSIONING_CANCEL_SUCCESS,
  AUTO_VERSIONING_CANCEL_FAILURE,

  AUTO_VERSIONING_ROLLBACK,
  AUTO_VERSIONING_ROLLBACK_SUCCESS,
  AUTO_VERSIONING_ROLLBACK_FAILURE,
} = actionTyper('autoVersioningActions')

export const { CLEAR_TOAST, TOAST_SHOWN } = actionTyper('toaster')
